import { render, staticRenderFns } from "./ConferenciaVolume.vue?vue&type=template&id=668c3d72"
import script from "./ConferenciaVolume.vue?vue&type=script&lang=js"
export * from "./ConferenciaVolume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports